/// <amd-module name="Wit/BoardsHub/KanbanBoard/Utils/FieldUtils" />
import { BoardFieldDefinition } from "Wit/BoardsHub/Common/KanbanBoardContracts";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";

export function getFieldEntriesFromBoardFields(fields: BoardFieldDefinition[]): IFieldEntry[] {
    // TODO: Would be better to just pass the list of IFieldEntry objects from the field service and map from BoardFieldDefinition
    return fields.map(
        field =>
            ({
                id: field.Id,
                isEditable: field.IsEditable,
                isIdentity: field.IsIdentity,
                name: field.Name,
                referenceName: field.ReferenceName,
                type: field.Type
            } as any as IFieldEntry)
    );
}
